import {
    CEREBRO_ACCESS_TOKEN,
    CEREBRO_ID_TOKEN,
    CEREBRO_RAIDER_ID_TOKEN,
    CEREBRO_REFRESH_TOKEN,
    COGNITO_ACCESS_TOKEN,
} from 'const/localStorage'
import { Login } from 'types/resources/auth'

import { createStorableAccessToken } from './accessToken'

export function setCerebroAuthTokens(
    accessToken: Login['access_token'],
    refreshToken: Login['refresh_token'],
    idToken: Login['id_token'],
    raiderIdToken: Login['raider_id_token']
): void {
    localStorage.setItem(CEREBRO_ACCESS_TOKEN, accessToken)
    localStorage.setItem(CEREBRO_REFRESH_TOKEN, refreshToken)
    localStorage.setItem(CEREBRO_ID_TOKEN, idToken)
    localStorage.setItem(CEREBRO_RAIDER_ID_TOKEN, raiderIdToken)
}

export function storeCognitoAccessToken(rawAccessToken: string): void {
    const accessToken = createStorableAccessToken(rawAccessToken)
    localStorage.setItem(COGNITO_ACCESS_TOKEN, JSON.stringify(accessToken))
}

export function deleteCerebroAuthTokens(): void {
    localStorage.removeItem(CEREBRO_ACCESS_TOKEN)
    localStorage.removeItem(CEREBRO_REFRESH_TOKEN)
    localStorage.removeItem(CEREBRO_ID_TOKEN)
    localStorage.removeItem(CEREBRO_RAIDER_ID_TOKEN)
    localStorage.removeItem(COGNITO_ACCESS_TOKEN)
}

export function isAuthenticated(): boolean {
    return !!localStorage.getItem(CEREBRO_ACCESS_TOKEN)
}
